import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import CachedIcon from '@material-ui/icons/Cached';
import ReplayIcon from '@material-ui/icons/Replay';
import BackspaceOutlinedIcon from '@material-ui/icons/BackspaceOutlined';
import PublishRoundedIcon from '@material-ui/icons/PublishRounded';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import EditIcon from '@material-ui/icons/Edit';
import { initialFen, emptyFen } from '../../utils.js';
import {
  faChessKnight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GetAppIcon from '@material-ui/icons/GetApp';
import TextField from '@material-ui/core/TextField';
import PgnFenDialog from './PgnFenDialog';
import { withStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert"

import { setToken, signInAnonymously } from '../../firebase/SignInWithFirebaseAnonymous.js';
import { getRemoteConfigs } from '../../firebase/FirebaseRemoteConfigs.js';

const ANALYZE = 'analyze';
const EDIT = 'edit';

const StyledTooltip = withStyles({
  tooltip: {
    color: "#ffffff",
    backgroundColor: "#7ab79e"
  }
})(Tooltip);

function pgnParser(pgn) {
  const pgnParts = pgn.split('\n');
  const pgnMoves = pgnParts[pgnParts.length - 1];
  return pgnMoves === "*" ? "" : pgnMoves;
}

function initParams(isLegalMoves) {
  const config = {
    isLegalMoves,
    lang: "en",
    boardSize: "m",
    notationStyle: "letters"
  }
  window.setInitialParams(config);
}

class Chessboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: ANALYZE,
      currentFen: initialFen,
      fenBeforeEdit: props.fen,
      currentPgn: "",
      dialogMode: null,
      anchorEl: null,
      setOpenErrorMessage: false,
      errorMessage: ""
    };
    window.isProEditMode = () => { return this.state.mode === EDIT };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.balance >= 10 && nextProps.balance < 10) {
      if (window.TAXTAK) {
        this.setMode();
      }
    }
    if (!this.props.isAnalysing && nextProps.isAnalysing) {
      this.setState({
        mode: ANALYZE
      }, () => {
        window.switchToAnalysisMode();
      });
    }
    if (this.props.fen !== nextProps.fen || this.props.pgn !== nextProps.pgn) {
      this.setState({
        currentFen: nextProps.fen,
        currentPgn: pgnParser(nextProps.pgn)
      })
    }

  }

  handleAnchorEl = (anchorEl) => {
    this.setState({ anchorEl })
  }

  setMode = () => {
    const { fen, pgn, mode, balance } = this.props;
    if (balance >= 10) {
      initParams(mode !== EDIT);
      window.analyzeContent = true;
      window.pro = true;
      setTimeout(() => {
        if (fen) window.TAXTAK.setFen(fen);
        if (pgn) window.TAXTAK.setPgn(pgn);
      }, 3000);
    } else {
      window.analyzeContent = (mode === ANALYZE);
      setTimeout(() => { window.TAXTAK.setBoardSize(); }, 1000);
      setTimeout(() => {
        if (fen) window.TAXTAK.setFen(fen);
        if (pgn) window.TAXTAK.setPgn(pgn);

        switch (mode) {
          case ANALYZE:
            setToken(() => {
              window.analyze();
            });
            break;
          case EDIT:
            setToken(() => {
              window.switchToEditMode();
            });
            break;
          default:
            console.log("Unhandled Mode !!!");
            break;
        }
      }, 2000);
    }
  }

  handleChangeToEdit = (event) => {
    const checked = event.target.checked;
    if (!checked && !window.validateCurrentPosition()) {
      return;
    }

    if (!checked && (window.getFen() !== this.state.fenBeforeEdit)) {
      window.emptyPgn();
      window.TAXTAK.getGame().header("FEN", window.getFen())
    }
    this.setState({
      mode: checked ? EDIT : ANALYZE
    }, () => {
      if (!checked) {
        window.switchToAnalysisMode();
      } else {
        this.setState({ fenBeforeEdit: window.TAXTAK.getFen() })
        window.switchToEditMode();
      }
    });
  }

  handleFlipBoard = () => {
    const turn = window.TAXTAK.getOrientation() === 'w' ? 'b' : 'w';
    window.setBoardOrientation(turn);
  }

  handleClearBoard = () => {
    window.emptyPgn();
    window.clearBoard();
  }

  handleResetBoard = () => {
    window.emptyPgn();
    window.resetToStartBoard()
  }

  downloadPGN = (filename) => {
    const pgn = window.getPgn();
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(pgn));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
    this.setState({ dialogMode: null });
  }

  uploadPgn = () => {
    if (this.state.currentPgn && window.isValidPgn(this.state.currentPgn)) {
      window.clearPgnViewer();
      window.setPgn(this.state.currentPgn)
    } else {
      this.setState({ setOpenErrorMessage: true, errorMessage: "PGN" });
    }
    this.setState({ dialogMode: null });
  }

  handleUploadClick = event => {
    var file = event.target.files[0];
    const reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      this.setState({
        selectedFile: [reader.result]
      });
    }.bind(this);
    console.log(url); // Would see a path?

  };


  handleClose = (event, reason) => {
    this.setState({ setOpenErrorMessage: false });
  };

  handleErrorMessage = () => {
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={this.state.setOpenErrorMessage}
        autoHideDuration={6000}
        onClose={this.handleClose}>
        <MuiAlert variant="filled" elevation={6} severity="error" onClose={this.handleClose}>
          Invalid {this.state.errorMessage}
        </MuiAlert>
      </Snackbar>
    )
  }

  setFenToBoard = () => {
    if (window.isValidFen(this.state.currentFen)) {
      window.resetToStartBoard()
      window.setFen(this.state.currentFen);
    } else {
      this.setState({ setOpenErrorMessage: true, errorMessage: "FEN" });
    }
    this.setState({ dialogMode: null });
  }

  handleFenChange = (e) => {
    this.setState({
      currentFen: e.target.value
    })
  }

  handlePgnChange = (e) => {
    this.setState({
      currentPgn: e.target.value
    })
  }

  render() {
    const { isAnalysing } = this.props;
    const { mode, dialogMode } = this.state;

    return (
      <div style={{ position: 'relative' }}>
        <iframe
          id="board_frame"
          src="https://chessify.me/board"
          style={{ width: '100vw', height: 'calc(100vh - 155px)' }}
          title="Board"
          frameBorder="0"
        ></iframe>
      </div>
    );
  }
}

Chessboard.propTypes = {
  classes: PropTypes.object.isRequired,
  pgn: PropTypes.string,
  fen: PropTypes.string
};

export default Chessboard;
